export default "__VITE_ASSET__CwZwBMhF__"